import { render, staticRenderFns } from "./mgcmanage_expand.vue?vue&type=template&id=88820456&scoped=true"
import script from "./mgcmanage_expand.vue?vue&type=script&lang=js"
export * from "./mgcmanage_expand.vue?vue&type=script&lang=js"
import style0 from "./mgcmanage_expand.vue?vue&type=style&index=0&id=88820456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88820456",
  null
  
)

export default component.exports